/**
 * Handles the user submit when applying filters.
 *
 */
const handleSubmit = (event) => {
	event.preventDefault();

	// Get the search filters
	const postTypeFilters = document.querySelector(
		'.wp-block-mavis-search-filters .mavisSearch-filter-options.is-post-types',
	);
	const sortingFilters = document.querySelector(
		'.wp-block-mavis-search-filters .mavisSearch-filter-options.is-sorting',
	);

	// Get the current url
	// eslint-disable-next-line no-undef
	const mavisURL = WPMAVISDATA.siteurl ?? window.location.href;
	const url = new URL(mavisURL);

	// Check for any search params
	const { searchParams } = url;

	// Clear all search params from url.
	const paramKeys = [...searchParams.entries()].map((entry) => entry[0]);
	paramKeys.forEach((key) => searchParams.delete(key));

	// Get all inputs inside the filter container and filter by checked only
	const checkedPostTypes = [...postTypeFilters.getElementsByTagName('input')].filter(
		(input) => input.checked,
	);

	// For each checked input get attributes and dataset
	checkedPostTypes.forEach((option) => {
		const { value } = option.attributes;

		// Set the name and value params
		searchParams.append('post_type[]', value.value);

		url.search = searchParams.toString();
	});

	// Get all inputs inside the filter container and filter by checked only
	const checkedSorting = [...sortingFilters.getElementsByTagName('input')].filter(
		(input) => input.checked,
	);

	// For each checked input get attributes and dataset
	checkedSorting.forEach((option) => {
		const { name, value } = option.attributes;
		const { order, orderBy } = option.dataset;

		searchParams.append(name.value, value.value);

		// Only set order and orderBy params if they exists
		if (order && orderBy) {
			searchParams.set(order, orderBy);
		}

		url.search = searchParams.toString();
	});

	const searchInput = document.querySelector('.wp-block-search__input');

	// Prepare user input for URL, but swap out %20 space encoding for +
	const searchTerm = encodeURIComponent(searchInput.value).replace(/%20/g, '+');

	const newURL = `${url.origin}${
		url.pathname !== '/' ? url.pathname : ''
	}/search/${searchTerm}?${searchParams.toString()}`;

	// Redirect page to new url that includes filter params
	window.location.replace(newURL);
};

window.addEventListener('DOMContentLoaded', () => {
	// Get search filters to check we're on the right page before continuing
	const searchFiltersBlock = document.querySelector('.wp-block-mavis-search-filters');

	// If search filter element does not exist return
	if (!searchFiltersBlock) {
		return;
	}

	// Get the search filters container
	const searchFilterContainer = document.querySelector(
		'.wp-block-mavis-search-filters .mavisSearch-filters-container',
	);

	// Get the button that toggles the filter dropdown
	const toggleFilterContainer = document.querySelector('.wp-block-mavis-search-filters button');

	// Get the toggle element
	const toggleFilterButton = document.querySelector('.mavisSearch-filter-toggle');

	// Get the apply filters button
	const applyFilters = document.querySelector(
		'.mavisSearch-filters-container .mavisApply-filters-button',
	);

	// Get the search url
	const urlWithQueries = window.location.search;

	const urlParams = new URLSearchParams(urlWithQueries);
	const decodedParamsString = decodeURI(urlParams.toString());

	// Get each of the params needed. Post type can either be post_type[] or post_type[x] where x is a key so need to match both.
	const postTypeFilters = [
		...decodedParamsString.matchAll(/post_type(?:\[\d*\])?=([^&[\]]*)/g),
	].map((match) => match[1]);
	const sortOrderFilter = urlParams.get('order');
	const sortByFilter = urlParams.get('orderby');

	// Foreach of those previously selected post type filters, check them on page load
	postTypeFilters.forEach((filter) => {
		const selectedPostTypes = document.querySelector(
			`.mavisSearch-filter-options.is-post-types div [value="${filter}" ]`,
		);

		if (selectedPostTypes) {
			selectedPostTypes.checked = true;
		}
	});

	// For the previously selected sort by filter, check it on page load
	const selectedSortOption = document.querySelector(
		`.mavisSearch-filter-options.is-sorting div [value="${sortByFilter}"][data-order-by="${sortOrderFilter}"]`,
	);

	if (selectedSortOption) {
		selectedSortOption.checked = true;
	}

	// When toggle button element is clicked, open/close the container by adding/removing is-open class
	toggleFilterContainer.addEventListener('click', () => {
		searchFilterContainer.classList.toggle('is-open');
		searchFilterContainer.toggleAttribute('inert');
	});

	// Add/remove is-open class on click
	toggleFilterButton.addEventListener('click', () => {
		toggleFilterButton.classList.toggle('is-open');
	});

	const coreSearchBtn = document.querySelector('button.wp-block-search__button');

	// On click of apply filters button fire handleSubmit function
	applyFilters.addEventListener('click', (e) => handleSubmit(e));
	coreSearchBtn.addEventListener('click', (e) => handleSubmit(e));
});
